import React, { useId } from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    label: string;
    value: string;
  }[];
}
export function Select({
  label,
  error,
  options,
  className = '',
  id,
  required,
  placeholder,
  ...props
}: SelectProps) {
  const selectId = id || useId();
  return <div className="w-full" data-id="element-205">
      {label && <label htmlFor={selectId} className="block text-sm font-normal text-[#3e3e3c] mb-1" data-id="element-206">
          {label} {required && <span className="text-[#ba0517]" data-id="element-207">*</span>}
        </label>}
      <select id={selectId} className={`
          w-full h-9 px-3 rounded-[4px] border bg-white text-[#080707] text-sm
          transition-shadow focus:outline-none focus:ring-1 focus:ring-[#0176d3] focus:border-[#0176d3]
          ${error ? 'border-[#ba0517] focus:ring-[#ba0517] focus:border-[#ba0517]' : 'border-[#dddbda]'}
          disabled:bg-[#f3f2f2] disabled:text-[#3e3e3c]
          ${className}
        `} {...props} data-id="element-208">
        {placeholder && <option value="" disabled data-id="element-209">
            {placeholder}
          </option>}
        {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-210">
            {opt.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-xs text-[#ba0517]" data-id="element-211">{error}</p>}
    </div>;
}